import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import { useAuthorization } from 'framework/authorization';
import {
  REUSE_PROJECT,
  useNewProjectUrl,
  useProjectDataContext,
  GET_PREDECESSOR_CANDIDATES,
} from 'domain/shared/newProject';
import { PredecessorProject } from './types';
import { buildSearchString, selectReuseSource } from './utils';

interface UseReuseDataLinkResult {
  isVisible: boolean;
  reuseUrl: string;
}

export const useReuseDataLink = (): UseReuseDataLinkResult => {
  const { getReuseDataUrl } = useNewProjectUrl();
  const { isGranted } = useAuthorization();
  const { data: project } = useProjectDataContext();
  const { id: projectId, name: codeName, accountData } = project;
  const accountId = accountData?.accountId;
  const isReuseGranted = Boolean(projectId) && isGranted(REUSE_PROJECT);

  const { data } = useQuery(GET_PREDECESSOR_CANDIDATES, {
    variables: { searchString: codeName && accountId ? buildSearchString(codeName, accountId) : '' },
    fetchPolicy: 'no-cache',
    skip: !projectId || !codeName || !accountId,
  });

  const baseProjects = (data as { baseProjects?: PredecessorProject[] } | undefined)?.baseProjects;
  const { hasTransferableData } = useMemo(() => selectReuseSource(baseProjects, projectId), [baseProjects, projectId]);

  return {
    isVisible: isReuseGranted && hasTransferableData,
    reuseUrl: getReuseDataUrl(projectId),
  };
};
